import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { DropdownMenuItem } from "@webapp/shared/dropdown/dropdown.models";
import { DropdownMenuItemBuilder } from "@webapp/shared/dropdown/util/dropdown-menu-item-builder";

@Component({
  selector: "apps-dropdown",
  templateUrl: "./apps-dropdown.component.html",
  styleUrls: ["./apps-dropdown.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppsDropdownComponent implements OnInit {
  @Input() public iconType = "gh-apps";
  @Input() public withoutBorderOnFocus = false;

  public appsMenuItems: DropdownMenuItem[];

  public ngOnInit(): void {
    this.appsMenuItems = this.getAppsMenuItems();
  }

  private getAppsMenuItems(): DropdownMenuItem[] {
    const menuItemBuilder = new DropdownMenuItemBuilder();

    return [
      menuItemBuilder
        .setKey("gtmhub")
        .setUiType({ iconTheme: "fill", uiType: "uiIcon", iconType: "quantive-circle-logo" })
        .setSelected()
        .setA11yDescriptionKey("gtmhub")
        .build(),

      menuItemBuilder
        .setKey("quantive_singularity")
        .setUiType({ iconTheme: "fill", uiType: "uiIcon", iconType: "quantive-circle-logo" })
        .setAction({ href: this.singularityURL(), target: "_blank" })
        .setA11yDescriptionKey("quantive_singularity")
        .build(),
    ];
  }

  private singularityURL(): string {
    // isSecondary param is used by singularity application to use auth0 universal login as SSO
    return "/singularity/login/?isSecondary";
  }
}
